import * as React from 'react';
import { useDynamicPhone, EPageTypes, EPlatformTypes } from '@cian/frontend-newbuilding-call-component';
import { useSelector } from 'react-redux';

import { BuilderChatPhone } from '../../components/BuilderChatPhone';
import { PhonesPreloader } from '../../components/PhonesPreloader';
import { getNewbuildingId } from '../../selectors/newbuilding';
import { useApplicationContext } from '../../utils/applicationContext';

const PRELOADER_HEIGHT = 52;

interface IBuilderChatDynamicPhoneProps {
  siteBlockId: number;
  notFormattedPhone: string;
  phoneNumber: string;
}

export const BuilderChatDynamicPhone = ({
  siteBlockId,
  phoneNumber,
  notFormattedPhone,
}: IBuilderChatDynamicPhoneProps) => {
  const { httpApi, logger } = useApplicationContext();
  const newbuildingId = useSelector(getNewbuildingId);

  const { dynamicPhone, responseEnded } = useDynamicPhone({
    formattedPhone: phoneNumber,
    notFormattedPhone,
    siteBlockId,
    httpApi,
    logger,
    placeType: 'ChatModal',
    pageType: EPageTypes.NewbuildingCard,
    platformType: EPlatformTypes.WebDesktop,
    announcementId: newbuildingId,
  });

  if (!responseEnded) {
    return <PhonesPreloader height={PRELOADER_HEIGHT} />;
  }

  return <BuilderChatPhone phone={dynamicPhone} />;
};
